module.exports = __webpack_public_path__ + "static/img/main-message.e277cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-message.png
// module id = G3i6
// module chunks = 1